<template>
  <div>
    <v-btn 
    v-show="isUsed"
    @click="clickIdentify" 
    color="primary"
    block
      :x-large="$vuetify.breakpoint.smAndUp ? true :false"
    elevation="0"
    :disabled="isPopupOpen"
    >
      {{ $t('signup.btn.nice_signup') }}
    </v-btn>

    <input type="hidden" id="inputKey" v-model="key"/>
    <input type="hidden" id="inputIv" v-model="iv" />
    
  </div>
</template>

<script>
import { $createRequestParam } from "@/redcrm/api/customer.js";
import {$getIdentifyConfig} from "@/redcrm/api/configs.js";
export default {
  components: {},
  data() {
    return {
      key: "",
      iv: "",
      isUsed:false,
      isPopupOpen:false,
    };
  },

  methods: {
    async getIdentifyConfig(){
      try {
        const { data } = await $getIdentifyConfig();
        const identify = JSON.parse(data.result.configVal);
        this.isUsed = identify.nice.isUsed
      } catch {
        this.$rxSnackbar("error", this.$t("common.msg.unexpected_error"));
      }
    },
    async clickIdentify() {
      // var host = window.location.host;
      // var pro = window.location.protocol;
      var origin = window.location.origin;
      const returnUrl = origin+ "/identifyResponse";
      const { data } = await $createRequestParam(returnUrl);
      const rst = data.result;
      this.key = rst.key;
      this.iv = rst.iv;
      
      const object = {
        tokenVersionId: rst.tokenVersionId,
        integrityValue: rst.integrityValue,
        encData: rst.encData,
      };

      const queryString = Object.keys(object)
        .map(
          (key) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`
        )
        .join("&");

      await window.open(
        `/identifyRequest?${queryString}`,
        "popup",
        "width=400, height=600"
      );
    },
    
    
  },
  created(){
    this.getIdentifyConfig();
  }
  
};
</script>


